import {
    binanceTransactionRouter,
    pancakeFactoryTokenInfo,
    pancakeRouterTokenInfo, uniswapFactoryTokenInfo, uniswapRouterTokenInfo,
    uniswapTransactionRouter
} from "./contracts";
import {
    bsc,
    BUSD_ADDRESS,
    BUSD_ETH_ADDRESS,
    PANCAKE_ROUTER_V2,
    uniswap,
    UNISWAP_ROUTER_V2,
    WBNB_ADDRESS,
    WETH_ADDRESS
} from "../const";

export const extractContractAddress = (value) => {
    let re = /0x/;
    const matchedValue = value.match(re);
    if (matchedValue) {
        const startAddress = matchedValue.index;
        const endAddress = startAddress + 42;
        const finalAddress = value.slice(startAddress, endAddress)
        return finalAddress
    }
    return ''
}

export const isHoneypot = async (tokenAddress) => {
    const myFetch = await fetch(`https://honeypot.api.rugdoc.io/api/honeypotStatus.js?address=${tokenAddress}&chain=bsc`);
    const result = await myFetch.json();
    if (result.status === 'SWAP_FAILED') {
        return true;
    }
    return false;
}

export const verifyBscApiKey = async (apikey) => {
    const apiVerificationUrl = `https://api.bscscan.com/api?module=account&action=balance&address=0x70F657164e5b75689b64B7fd1fA275F334f28e18&apikey=${apikey}`
    let isValidKey = true;
    const fetchDataWithKey = await fetch(apiVerificationUrl)
        .then(async (res) => await res.json())
        .catch(e => console.log(e));
    console.log("fetch data key: ", fetchDataWithKey);
    console.log("fetch data key result: ", fetchDataWithKey.result);
    if (fetchDataWithKey.result === 'Invalid API Key') {
        return false;
    }
    return isValidKey;
}

export const parseAbi = (abi) => {
    let functionToPush = '';
    let abiFunctions = [];
    abi = JSON.parse(abi);
    for (let i = 0; i < abi.length; i++) {
        if (!abi[i].name || abi[i].type !== 'function') {
            continue;
        }
        if (abi[i].name && abi[i].type === 'function' && abi[i].stateMutability && abi[i].stateMutability === 'nonpayable') {
            functionToPush = abi[i].name;
            if (abi[i].inputs.length > 0) {
                const inputsLength = abi[i].inputs.length;
                const inputs = abi[i].inputs;
                const comma = ',';
                let inputName = '';
                for (let j = 0; j < inputsLength; j++) {
                    inputName += inputs[j].type;
                    if (j + 1 < inputsLength) {
                        inputName += comma;
                    }
                }
                functionToPush += `(${inputName})`
                abiFunctions.push(functionToPush);
            } else {
                functionToPush += '()';
                abiFunctions.push(functionToPush);
            }
        }
    }
    return abiFunctions;
}

export const getOwner = async (ca) => {
    let ownerAddress = '';
    try {
        ownerAddress = await ca.getOwner()
    } catch (e) {
        console.log(e);
    }
    if (!ownerAddress) {
        try {
            ownerAddress = await ca.owner();
        } catch (e) {
            console.log(e);
        }
    }
    if (!ownerAddress) {
        try {
            ownerAddress = await ca._owner();
        } catch (e) {
            console.log(e);
        }
    }
    return ownerAddress;
}

export const getSymbolFromChain = (chain) => {
    switch (chain) {
        case bsc:
            return 'BNB';
        case uniswap:
            return 'ETH';
    }
}

export const getCoinAddressByChain = (chain, selectedToken) => {
    switch (chain) {
        case bsc:
            if (selectedToken && selectedToken === 'busd') {
                return BUSD_ADDRESS;
            }
            return WBNB_ADDRESS;
        case uniswap:
            return WETH_ADDRESS;
    }
}

export const getChainRouter = (chain, account) => {
    switch (chain) {
        case bsc:
            return binanceTransactionRouter(account);
        case uniswap:
            return uniswapTransactionRouter(account);
    }
}

export const getTokenUSDPair = async (chain) => {
    switch (chain) {
        case bsc:
            let tokenInfo = await pancakeRouterTokenInfo.functions.getAmountsOut((1e18).toString(), [WBNB_ADDRESS, BUSD_ADDRESS]);
            return tokenInfo
        case uniswap:
            let tokenInfoUni = await uniswapRouterTokenInfo.functions.getAmountsOut((1e18).toString(), [WETH_ADDRESS, BUSD_ETH_ADDRESS]);
            return tokenInfoUni
    }
}

export const getLPAddressByChain = async (chain, tokenAddress) => {
    switch (chain) {
        case bsc:
            return await pancakeFactoryTokenInfo.functions.getPair(tokenAddress, WBNB_ADDRESS);
        case uniswap:
            return await uniswapFactoryTokenInfo.functions.getPair(tokenAddress, WETH_ADDRESS);
    }
}

export const getRouterAddressByChain = (chain) => {
    switch (chain) {
        case bsc:
            return PANCAKE_ROUTER_V2
        case uniswap:
            return UNISWAP_ROUTER_V2
    }
}

export const getAmountsOutByChain = async (chain, decimals, tokenAddress) => {
    switch (chain) {
        case bsc:
            return await pancakeRouterTokenInfo.functions.getAmountsOut((10 ** decimals).toString(), [tokenAddress, WBNB_ADDRESS]);
        case uniswap:
            return await uniswapRouterTokenInfo.functions.getAmountsOut((10 ** decimals).toString(), [tokenAddress, WETH_ADDRESS]);
    }
}

export const removeCommas = (value) => parseFloat(value.replace(/,/g, ''));